import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { Layer, LayerCreate } from "@farm/domain/models/layer.model";
import type { FarmRepository } from "@farm/domain/repositories/farm.repository";
import { farmTypes } from "@farm/farm-types.di";
import { RecuperableModelError } from "@iot-platform/core";
import { inject, injectable } from "inversify";

@injectable()
export class LayerFetchUseCase {
    constructor(
        @inject(farmTypes.repositories.FarmRepository)
        private readonly farmRepository: FarmRepository,
    ) {}

    async execute(
        farmId: string,
        plotId: string,
        createLayer: LayerCreate,
    ): Promise<Nullable<Layer>> {
        const result = await this.farmRepository.fetchLayer(
            farmId,
            plotId,
            createLayer,
        );

        return result.match(
            (layer) => layer,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);
                    return error.instance;
                }

                return null;
            },
        );
    }
}
